module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAABJ0lEQVQ4T4XSPSiGURjG8Z/IRgZlUCYpGQySJIOUEiXJahGKwWAwkIliYhKjkfKZQkjJppSUgSKDTShhkNKp8+rp6X05233O/b+u+1zn5Mm+CrCJTnRjK1tbXg64ARvowCnK8ZbuzQYX4ja6XmEP21j6Dw4O7RhDdWwuxkMUu8BnRiQ492IEVXG04DaF64RTqJtQi3ecYzLAHxFeiwc5YvjdLsUKbgK8iMoYztd/JBqxjr4A52MZ9WjB8x8CXTG4Aexm0g4C4+hBXQ64AiGwVlyGnuRTBddZhDfOtZ5Qhu80HBKvwXCCLMFror6LzvdpeB8LOEAbJtAc7ziNRxxiDkdp+BjhT4exXjCDs5jFKFbjR+nHThoOgQzhJKOcGLcIgzGj+cydfwAsyDsGD0C/oAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancleCollectIcon.png
// module id = bJb6
// module chunks = 3